module.exports = __webpack_public_path__ + "img/img_safety_thumb.e437e5e0.jpeg";